import styled from '@emotion/styled'

type ListGridProps = {
	children: React.ReactNode | React.ReactNode[]
}

const TableSection = ({ children }: ListGridProps) => {
	return (
		<Block>
			<Table>{children}</Table>
		</Block>
	)
}

const Block = styled.div`
	width: 100%;
	overflow-x: scroll;
	overflow-y: hidden;
`

const Table = styled.table`
	border-collapse: collapse;
	width: 100%;
`

export default TableSection
